import { SupervisorAgentDto } from "@/components/organisms/supervisor/types";
import { Client, mapUrl } from "../client";
import { Controller } from "../controller";
import { Endpoint } from "../endpoint";
import {
	QueueType,
	RefreshStatus,
	SupervisedQueue,
	SupervisedQueues,
} from "../models";
import { SupervisorAgentsFilterData } from "@/repository/models";

export const fetchSupervisorAgents = (
	filterData: SupervisorAgentsFilterData
): Promise<SupervisorAgentDto[]> => {
	return Client.instance.post<SupervisorAgentDto[]>(
		mapUrl(Controller.Supervisor, Endpoint.Agents),
		filterData
	);
};

export const checkAgentIfSupervisor = (agentId: string): Promise<boolean> => {
	return Client.instance.get<boolean>(
		mapUrl(Controller.Supervisor, Endpoint.IsSupervisor),
		{ agentId }
	);
};

export const fetchSupervisedQueues = async (): Promise<SupervisedQueue[]> => {
	return Client.instance.get<SupervisedQueue[]>(
		mapUrl(Controller.Supervisor, Endpoint.Queues)
	);
};

export const updateOfferCallsToAgentsWithoutClient = (
	data: SupervisedQueue
): Promise<any> => {
	const url = mapUrl(
		Controller.SupervisorVoice,
		Endpoint.Queues,
		Endpoint.OfferCallsToAgentsWithoutClient
	);

	return Client.instance.post(url, data);
};

export const updateEstimatedWaitTime = (
	data: SupervisedQueue
): Promise<any> => {
	const url = mapUrl(
		Controller.SupervisorVoice,
		Endpoint.Queues,
		Endpoint.EstimatedWaitTime
	);

	return Client.instance.post(url, data);
};

export const setQueueJoinStatus = (data: SupervisedQueues): Promise<any> => {
	const action = data.isJoined ? Endpoint.Join : Endpoint.UnJoin;
	const url = mapUrl(mapQueueType(data.type!), Endpoint.Queues, action);

	return Client.instance.post(url, data);
};

export const setQueueDesire = (data: SupervisedQueue): Promise<any> => {
	const url = mapUrl(mapQueueType(data.type), Endpoint.Queues, Endpoint.Desire);

	return Client.instance.post(url, data);
};

export const refreshOtherAccount = (agentId: string, deleteOngoingCall: boolean): Promise<RefreshStatus> =>
	Client.instance.post(
		mapUrl(Controller.Supervisor, Endpoint.Refresh, agentId), deleteOngoingCall
	);

export const signOutOtherAgent = async (agentId: string): Promise<void> =>
	Client.instance.post(
		mapUrl(Controller.Supervisor, Endpoint.SignOut, agentId)
	);

const mapQueueType = (type: QueueType): Controller => {
	switch (type) {
		case QueueType.Voice:
			return Controller.SupervisorVoice;
		case QueueType.Messaging:
			return Controller.SupervisorMessaging;
		default:
			throw `Queue type [${QueueType[type]}] is not configured`;
	}
};
